<template>
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 flex items-center">
      <!-- Icon or indicator -->
      <div :class="`flex items-center justify-center p-3 rounded-full ${iconBgColor}`">
        <slot name="icon">
          <svg 
            v-if="iconName"
            class="w-6 h-6 text-white"
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path v-if="iconName === 'users'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            <path v-if="iconName === 'chart'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            <path v-if="iconName === 'star'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
            <path v-if="iconName === 'cash'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </slot>
      </div>
      
      <!-- Stats info -->
      <div class="ml-4">
        <p class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ title }}</p>
        <div class="flex items-baseline">
          <p class="text-2xl font-semibold text-gray-800 dark:text-gray-200">{{ value }}</p>
          <p v-if="change !== null" class="ml-2 text-sm" :class="changeTextColor">
            <span v-if="change > 0">+</span>{{ change }}%
          </p>
        </div>
        <p v-if="subtitle" class="text-xs text-gray-500 dark:text-gray-400 mt-1">{{ subtitle }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StatsCard',
    props: {
      title: {
        type: String,
        required: true
      },
      value: {
        type: [String, Number],
        required: true
      },
      change: {
        type: Number,
        default: null
      },
      subtitle: {
        type: String,
        default: ''
      },
      iconName: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: 'blue' // 'blue', 'green', 'red', 'yellow', 'purple'
      }
    },
    computed: {
      iconBgColor() {
        const colors = {
          blue: 'bg-blue-500',
          green: 'bg-green-500',
          red: 'bg-red-500',
          yellow: 'bg-yellow-500',
          purple: 'bg-purple-500'
        };
        
        return colors[this.color] || colors.blue;
      },
      changeTextColor() {
        if (this.change === null) return '';
        return this.change > 0 
          ? 'text-green-500' 
          : this.change < 0 
            ? 'text-red-500' 
            : 'text-gray-500 dark:text-gray-400';
      }
    }
  };
  </script>